var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;



/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/~/core-js/library/modules/_wks.js
 ** module id = 71
 ** module chunks = 0
 **/